import { render } from "./app-footer.vue?vue&type=template&id=194c1bad"
import script from "./app-footer.vue?vue&type=script&lang=js"
export * from "./app-footer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/layout/app-footer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "194c1bad"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('194c1bad', __exports__)) {
    console.log('reload')
    api.reload('194c1bad', __exports__)
  }
  
  module.hot.accept("./app-footer.vue?vue&type=template&id=194c1bad", () => {
    console.log('re-render')
    api.rerender('194c1bad', render)
  })

}


export default __exports__